<div [formGroup]="form">
  <div [formGroupName]="question.key" #raptorRepeaterMultiple>
    <div *ngFor="let group of question.fields; let i = index;">
      <div class="flex raptor-repeater-questions-panel-wrapper">
        
        <div class="raptor-repeater-questions-panel margin-left-none margin-right-none">
          <div *ngFor="let row of group" class="raptor-repeater-questions grid">
            <div *ngFor="let field of row" [class]="raptorDataService.columnLayoutClass(columns, field)">
              <div *ngIf="field.type !== 'hidden'">
                <open-raptor-question *ngIf="field.type && showQuestion(field)" [question]="field" [form]="form" [submitted]="submitted"></open-raptor-question>
                <open-raptor-component *ngIf="field.component" [form]="form" [type]="field.component" [config]="field"></open-raptor-component>
              </div>
            </div>
          </div>
        </div>

        <div class="flex-shrink raptor-repeater-multiple-remove" [hidden]="question.settings && question.settings.hide_cta">
          <button mat-icon-button color="primary" type="button" (click)="remove(group, i)"><mat-icon class="delete material-icons-outlined"></mat-icon></button>
        </div>

      </div>
    </div>

    <div class="raptor-repeater-multiple-add margin-top-small" [hidden]="(question.settings && question.settings.hide_cta) || maxItems()">
      <button mat-stroked-button color="secondary" type="button" class="margin-right-small" (click)="add()"><mat-icon class="add margin-right-small"></mat-icon>{{ question.settings && question.settings.cta_label ? question.settings.cta_label : 'Add' }}</button>
    </div>
  </div>
</div>